export default __webpack_public_path__ + "static/media/youtube-placeholder.aca6c8d6.jpg";